import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import {
  capitalizeFirstLetter,
  initialFilters,
  underscoreToFriendlyName,
} from '../../utils/helper';
import {
  useGetOrderByAdminQuery,
  useGetOrderByVendorQuery,
} from './ordersApiSlice';
import useRole from '../../hooks/useRole';
import CustomDropdown from '../../app/components/dropdown/CustomDropDown';
import DropdownItem from 'react-bootstrap/DropdownItem';
import { Container } from 'react-bootstrap';
import StyledColoredTag from '../../app/components/styledComponents/StyledColoredTag';
import CircleIcon from '../../app/components/svgIcons/CircleIcon';
import { orderStatuses } from './assets/orderUtil';
import ShowRejectedReasonModal from './components/ShowRejectedReasonModal';
import useAuth from '../../hooks/useAuth';
import OrdersHeader from './components/OrdersHeader';
import OrderTableView from './components/OrderTableView';
import SendOrdersListView from './components/SendOrdersListView';
import EyeIcon from './assets/images/eye';
import { useSelector } from 'react-redux';

const Orders = () => {
  const theme = useSelector((state) => state.theme);
  const { role } = useRole();
  const { user } = useAuth();
  const [searchValue, setSearchValue] = useState('');
  const [activeTab, setActiveTab] = useState('New Order');
  const [rejectionReason, setRejectionReason] = useState('');
  const [listing, setListing] = useState({ ...initialFilters });

  const [selectedOrderType, setSelectedOrderType] =
    useState('Receivered Orders');

  const navigation = useNavigate();
  const call =
    role.name === 'Vendor' ? useGetOrderByVendorQuery : useGetOrderByAdminQuery;

  const params = {
    ...listing,
  };

  let { data, refetch } = call(params, { forceRefetch: true });

  useEffect(() => {
    refetch();
  }, []);

  const handlePerPageChange = async (size) => {
    setListing((prevState) => ({
      ...prevState,
      page: 0,
      size,
    }));
  };

  const handlePageChange = async (selected) => {
    setListing((prevState) => ({
      ...prevState,
      page: selected,
    }));
  };

  const getVaraintColor = (tag) => {
    if (tag === orderStatuses.ORDER_REJECTED) {
      return 'danger';
    } else if (tag === orderStatuses.ORDER_ASSIGNED) {
      return 'success';
    } else {
      return 'blue';
    }
  };

  const column = [
    {
      id: 1,
      // path: 'custCompany',
      label: 'Florist',
      content: (order) => (
        <div>
          {order?.vendorId === user?.floristId ? (
            <>{order?.sendingVendorName || '-'}</>
          ) : (
            <>{order?.receivingVendorName || '-'}</>
          )}
        </div>
      ),
    },
    {
      id: 2,
      path: 'custFirst',
      label: 'Customer First Name',
    },
    {
      id: 3,
      path: 'custLast',
      label: 'Customer Last Name',
    },
    {
      id: 4,
      path: 'orderNo',
      label: 'Order Number',
    },
    {
      id: 5,
      path: 'delDate',
      label: 'Delivery Date',
    },
    {
      id: 6,
      path: 'orderStatus',
      label: 'Order Status',
      content: (order) => (
        <div>
          <StyledColoredTag
            className={` ${
              order?.orderStatusId === orderStatuses.ORDER_REJECTED
                ? 'cursor-pointer'
                : ''
            }`}
            style={{ width: 'fit-content' }}
            variant={getVaraintColor(order?.orderStatusId)}
            $marginX={'0'}
            onClick={() => setRejectionReason(order?.statusMessage || '')}
          >
            <CircleIcon className="me-1" />
            {capitalizeFirstLetter(
              underscoreToFriendlyName(order?.orderStatus),
            ) || ''}
          </StyledColoredTag>
        </div>
      ),
    },
    {
      id: 7,
      isChecked: true,
      label: 'Actions',
      content: (order) => (
        <CustomDropdown
          toggleClassName={'bg-transparent'}
          menuClassName={'table-dropdown'}
          dropdownToggle={<EyeIcon stroke={theme.primary} />}
          dropdownMenu={
            <>
              {order?.operations?.canEdit && (
                <DropdownItem as={Link} to={`/orders/${order.id}`}>
                  Edit
                </DropdownItem>
              )}

              <DropdownItem as={Link} to={`/orders/details/${order.id}`}>
                Order Details
              </DropdownItem>
            </>
          }
        />
      ),
    },
  ];

  const ordersCateory = [
    {
      order: 1,
      heading: 'New Order',
    },
    {
      id: 2,
      heading: 'Active Order',
    },
    {
      id: 3,
      heading: 'Todays Order',
    },
    {
      id: 4,
      heading: 'Sent Orders',
      label: 'Florist Name',
    },
    {
      id: 5,
      heading: 'History',
    },
  ];

  return (
    <>
      <RootContainer>
        <Container fluid>
          <OrdersHeader
            navigateToNewOrder={() => navigation('/orders/new')}
            setOrderType={setSelectedOrderType}
            {...{
              searchValue,
              setSearchValue,
            }}
          />

          {selectedOrderType === 'Receivered Orders' && (
            <ActivityTabs className="bg-white">
              {ordersCateory.map((column) => (
                <span
                  key={column.id || column.key}
                  className={column.heading === activeTab ? 'active' : ''}
                  onClick={() => setActiveTab(column.heading)}
                >
                  {column.heading}
                </span>
              ))}
            </ActivityTabs>
          )}

          {selectedOrderType === 'Receivered Orders' ? (
            <OrderTableView
              columns={column}
              tableData={data?.objectData ? data?.objectData : []}
              handlePerPageChange={handlePerPageChange}
              handlePageChange={handlePageChange}
            />
          ) : (
            <SendOrdersListView
              tableData={data?.objectData ? data?.objectData : []}
            />
          )}
        </Container>
      </RootContainer>
      <ShowRejectedReasonModal
        rejectReason={rejectionReason}
        onHide={() => setRejectionReason('')}
      />
    </>
  );
};

export const RootContainer = styled.div`
  font-family: 'SourceSansPro';
  font-size: 16px;
  color: ${({ theme }) => theme.primaryLight3};
  padding: 12px 32px 12px 32px;
  font-weight: 400;
  .form-check-input:checked {
    background-color: ${({ theme }) => theme.mainPrimary};
    border-color: ${({ theme }) => theme.mainPrimary};
  }
  .form-check-input:focus {
    box-shadow: none;
  }
  .col-xxl-3 {
    @media screen and (min-width: 1400px) {
      width: 25%;
      flex: 0 0 auto;
    }
  }
  .main-container {
    background-color: ${({ theme }) => theme.white};
  }
`;

export const ActivityTabs = styled.div`
  font-size: 18px;
  display: flex;

  justify-content: space-between;
  margin-bottom: 0;
  overflow-x: auto;
  > span {
    white-space: nowrap;
    padding: 20px ${({ underline }) => (underline === 'fit' ? 0 : '40px')};
    color: ${({ theme }) => theme.bodyMedium};
    background-color: ${({ theme }) => theme.dark90};
    border: 1px solid ${({ theme }) => theme.dark70};

    justify-content: space-between;
    text-align: center;
    font-size: 20px;
    cursor: pointer;
    position: relative;
    font-weight: 500;
    &:first-child {
      border-left: 0;
    }
    &.active {
      border-top: 0 !important;
      &:first-child {
        border-left: 0;
      }
      background-color: ${({ theme }) => theme.white};
      border: 1px solid ${({ theme }) => theme.white};
    }
  }
`;

export default Orders;
